import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import slide_1 from "../../fourthAssets/Images/slide-1.jpg";
import slide_2 from "../../fourthAssets/Images/slide-2.png";
import slide_3 from "../../fourthAssets/Images/slide-3.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom";

function ImageSlider(props) {
    const [isVisible, setIsVisible] = useState(false);
    const [nextImage, setNextImage] = useState(null);
    const [prevImage, setPrevImage] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const { selectedLanguage } = props;
    const history = useHistory()

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const CustomNextArrow = ({ onClick }) => (
        <div
            className="custom-arrow next"
            onClick={() => { onClick(); setIsVisible(false); }}
            onMouseEnter={() => setNextImage(currentSlide === 0 ? slide_2 : (currentSlide === 1 ? slide_3 : slide_1))}
            onMouseLeave={() => setNextImage(null)}>
            <FaChevronRight />
            {nextImage && <img src={nextImage} alt="next" className="preview-image next-image" />}
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div
            className="custom-arrow prev"
            onClick={() => { onClick(); setIsVisible(false); }}
            onMouseEnter={() => setPrevImage(currentSlide === 0 ? slide_3 : (currentSlide === 1 ? slide_1 : slide_2))}
            onMouseLeave={() => setPrevImage(null)}>
            <FaChevronLeft />
            {prevImage && <img src={prevImage} alt="prev" className="preview-image" />}
        </div>
    );

    const handleSlideChange = (current) => {
        setCurrentSlide(current);
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        afterChange: handleSlideChange
    };

    console.log('visible', isVisible);
    return (
        <div className="slider-container">
            <Slider {...settings}>
                <div className="frth-home-slider">
                    <img src={slide_1} alt="img" />
                    <div>
                        <h1 data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_welcome_to_cairo_capital_clinics}
                        </h1>
                        <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_healthcare_reimagined}
                        </h2>
                        <button data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000" onClick={()=> history?.push(allPaths?.FOURHTSERVICE)}>{selectedLanguage?.txt_view_services}</button>
                    </div>
                </div>
                <div className="frth-home-slider">
                    <img src={slide_2} alt="img" />
                    <div>
                        <h1 data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_best_doctors_in_egypt}
                        </h1>
                        <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_we_care_about_your_health}
                        </h2>
                        <button data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000" onClick={()=> history?.push(allPaths?.FOURHTDOCTORS)}>{selectedLanguage?.txt_check_our_doctors}</button>
                    </div>
                </div>
                <div className="frth-home-slider">
                    <img src={slide_3} alt="img" />
                    <div>
                        <h2 data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_top_notch_medical_facilities}
                        </h2>
                        <p data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                            {selectedLanguage?.txt_we_use_the_latest_technologies}
                        </p>
                        <button data-aos="fade-up"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000" onClick={()=> history?.push(allPaths?.FOURHTCONTACT)}>{selectedLanguage?.txt_contact_}</button>
                    </div>
                </div>
            </Slider>
        </div>
    );
}

export default ImageSlider;
